import React, { lazy, memo } from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
export const Testimonials = memo(function Testimonials() {
  const testimonials = [{
    name: 'Romina G.',
    location: 'Rosario, Santa Fe',
    text: 'Nunca había armado una decoración en mi vida. Con este kit tuve la fiesta de mi hija lista en 40 minutos. Mis amigas me preguntaron quién me lo había hecho y cuando les dije que yo sola no lo podían creer. Ya tengo tres clientas nuevas.',
    image: 'https://cdn.magicpatterns.com/uploads/7nsZEeCSbBpAXDetFQJ8Tm/pexels-juanfran-1413179368-30632254.jpg'
  }, {
    name: 'Valentina M.',
    location: 'CABA',
    text: 'Gasté una fortuna en una decoradora el año pasado y quedó horrible. Este año usé el kit y quedó diez veces mejor. Nunca más contrato a nadie.',
    image: 'https://cdn.magicpatterns.com/uploads/nEXas1mDHwyW4Zz6KbbXSH/pexels-tima-miroshnichenko-8727441.jpg'
  }, {
    name: 'Camila R.',
    location: 'Córdoba',
    text: 'Soy mamá de tres nenes y siempre llegaba al cumpleaños sin decoración porque no tenía tiempo. Ahora en una hora tengo todo listo. Mi nena lloró de emoción cuando vio su mesa dulce.',
    image: 'https://cdn.magicpatterns.com/uploads/bDDFZJXikX1w1Wgg2yj91y/portrait-attractive-young-dark-haired-woman-home-light-room-beautiful-female-looking-camera-with-calm-facial-expression-wearing-white-shirt-indoor-shot.jpg'
  }, {
    name: 'Lorena P.',
    location: 'Mendoza',
    text: 'Empecé usándolo para la fiesta de mi sobrino y terminé armando un emprendimiento. Ya tengo 12 clientas fijas y me pagan muy bien. La inversión se pagó sola en la primera semana.',
    image: 'https://cdn.magicpatterns.com/uploads/9Z2Umvur1xtFUZdNQ2JUNg/portrait-woman-lying-bed.jpg'
  }, {
    name: 'Gabriela T.',
    location: 'Tucumán',
    text: 'Tenía miedo de que fuera complicado porque no sé nada de diseño. Pero las plantillas en Canva son tan fáciles que mi hija de 12 años me ayudó a editarlas. Quedaron hermosas y las imprimimos en casa.',
    image: 'https://cdn.magicpatterns.com/uploads/guGa55zMMPsyxaqJNQNBFi/young-woman-smiling-green-spring-garden.jpg'
  }, {
    name: 'Mariana S.',
    location: 'Rosario, Santa Fe',
    text: 'Lo compré un viernes a la noche porque el cumpleaños era el sábado. En dos horas tenía toda la decoración lista e impresa. Salvó mi vida. Lo recomiendo a todas las mamás.',
    image: 'https://cdn.magicpatterns.com/uploads/p6fvY79oktmSkvZG2bb4QF/pexels-dionizzio-geronimo-243131711-12334082.jpg'
  }, {
    name: 'Florencia D.',
    location: 'Mar del Plata',
    text: 'Compré varios packs de otros lados y siempre me decepcioné. Este es diferente. La calidad de los diseños es increíble, parecen hechos por una diseñadora profesional. Vale cada peso.',
    image: 'https://cdn.magicpatterns.com/uploads/udY9XBQMHbaiywCAR9TeTb/pexels-marcocarnemollaph-13872834.jpg'
  }, {
    name: 'Natalia B.',
    location: 'La Plata',
    text: 'Llevo 6 meses usando el kit para mi negocio de decoración. Mis clientas quedan encantadas y yo ahorro horas de trabajo. Sin este kit no podría atender la cantidad de pedidos que tengo ahora.',
    image: 'https://cdn.magicpatterns.com/uploads/opxbdt5sNj8Kuk5iTfFfWW/pexels-sweeming-young-418924930-35968859.jpg'
  }];
  return <section className="py-4 px-4 bg-transparent" data-id="element-220">
      <div className="max-w-6xl mx-auto" data-id="element-221">
        <div className="text-center mb-6" data-id="element-222">
          <div className="inline-block bg-primary/10 text-primary font-bold text-xs px-4 py-1.5 rounded-full mb-4 tracking-wider uppercase" data-id="element-223">
            ✨ Casos de Éxito
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-dark mb-3 tracking-tight" data-id="element-224">
            Lo Que Dicen Nuestras <span className="text-primary" data-id="element-225">Clientas</span>
          </h2>
          <p className="text-base md:text-lg text-body/80 font-medium" data-id="element-226">
            No me creas a mí. Escuchá a ellas... 👇
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-227">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          delay: i * 0.08,
          duration: 0.4
        }} className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 relative" data-id="element-228">
              <div className="flex gap-0.5 mb-2" data-id="element-229">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-3 h-3 fill-accent text-accent" data-id="element-230" />)}
              </div>
              <p className="text-xs text-body/80 leading-relaxed mb-3 italic" data-id="element-231">
                "{t.text}"
              </p>
              <div className="flex items-center gap-2" data-id="element-232">
                <img src={t.image} alt={t.name} className="w-7 h-7 rounded-full object-cover flex-shrink-0" loading="lazy" width={28} height={28} data-id="element-233" />
                <div data-id="element-234">
                  <p className="font-semibold text-dark text-xs leading-tight" data-id="element-235">
                    {t.name}
                  </p>
                  <p className="text-[10px] text-gray-400" data-id="element-236">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
});